import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./selected_service.module.scss"

export default class SelectedService extends Component {
  onServiceDeselect = () => {
    this.props.onServiceDeselect(this.props.service)
  }

  render() {
    const service = this.props.service
    return (
      <div className={classnames("input", "new-connect-ui", styles["with-close-option"])}>
        <input type="text" value={service.name} disabled />
        <div
          className={styles["dropdown-service-tile"]}
          style={{
            backgroundColor: `#${service.brand_color}`,
          }}
        >
          <img
            src={service.lrg_monochrome_image_url}
            alt={service.name}
            title={service.name}
          />
        </div>
        <div
          className={classnames("close-btn", styles["close-btn"])}
          onClick={this.onServiceDeselect}
          title="Click to select another service"
          aria-label="Click to select another service"
        ></div>
      </div>
    )
  }
}

SelectedService.propTypes = {
  service: PropTypes.shape({
    id: PropTypes.string,
    module_name: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onServiceDeselect: PropTypes.func.isRequired,
}
